import xhr from '../utils/fetch';

const createTicket = async (ticket: any) => {
  return await xhr({
    url: `/tickets`,
    method: 'POST',
    body: ticket
  }).then((res) => res);
};

const ticketsApi = {
  createTicket
};

export default ticketsApi;